export default __webpack_public_path__ + "static/media/logo-dho-sispack-negativo.30df2923.svg";